import React, { useState } from "react";
import diamondDummy from "../../assets/diamonds/diamond_round.png";
import { FaChevronDown, FaChevronRight, FaChevronUp } from "react-icons/fa";

const DiamondListView = ({ diamonds }) => {
  const [expanded, setExpanded] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    id: true,
    image: true,
    shape: true,
    color: true,
    carat: true,
    price_per_carat: true,
    total_price: true,
    clarity: true,
    ratio: true,
    lab: true,
    cut: true,
    polish: true,
    symmetry: true,
    depth_percentage: true,
    table_percentage: true,
    fluorescent: true,
    culet: true,
    certificate_number: true,
    // location: true,
    // created_at: true,
    // type: true,
    certificate_url: true,
  });

  const toggleColumn = (column) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  const formatValue = (key, value) => {
    if (key === "image_url") {
      return value ? (
        <img
          src={value}
          className="img-thumbnail"
          style={{ maxWidth: "100px" }}
          alt="Diamond"
        />
      ) : (
        <img
          src={diamondDummy}
          className="img-thumbnail"
          style={{ maxWidth: "100px" }}
          alt="Diamond"
        />
      );
    }

    if (key === "certificate_url") {
      return value ? (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-outline-primary"
        >
          View
        </a>
      ) : (
        "-"
      );
    }

    if (key === "created_at") {
      return new Date(value).toLocaleString();
    }

    if (key === "price_per_carat" || key === "total_price") {
      return `$${parseFloat(value).toFixed(2)}`;
    }

    return value;
  };

  return (
    <div className="container diamond-list-view">
      {/* Column Visibility Toggles */}
      <div className="mb-4 p-3 border rounded bg-light">
        <div className="visible-columns" onClick={() => setExpanded(!expanded)}>
          <div className={`${expanded ? "mb-3" : ""} label`}>
            Visible Columns Filters
          </div>
          <div>{expanded ? <FaChevronUp /> : <FaChevronDown />}</div>
        </div>
        {expanded && (
          <div className={`switch-grid`}>
            {Object.keys(visibleColumns).map((column) => (
              <div className="form-check form-switch" key={column}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`toggle-${column}`}
                  checked={visibleColumns[column]}
                  onChange={() => toggleColumn(column)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`toggle-${column}`}
                >
                  {column.replace(/_/g, " ")}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Diamond Table */}
      <div className="table-responsive table-view">
        <table className="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              {visibleColumns.id && <th>ID</th>}
              {visibleColumns.image && <th>Image</th>}
              {visibleColumns.shape && <th>Shape</th>}
              {visibleColumns.color && <th>Color</th>}
              {visibleColumns.carat && <th>Carat</th>}
              {visibleColumns.price_per_carat && <th>Price/Carat</th>}
              {visibleColumns.total_price && <th>Total Price</th>}
              {visibleColumns.clarity && <th>Clarity</th>}
              {visibleColumns.ratio && <th>Ratio</th>}
              {visibleColumns.lab && <th>Lab</th>}
              {visibleColumns.cut && <th>Cut</th>}
              {visibleColumns.polish && <th>Polish</th>}
              {visibleColumns.symmetry && <th>Symmetry</th>}
              {visibleColumns.depth_percentage && <th>Depth %</th>}
              {visibleColumns.table_percentage && <th>Table %</th>}
              {visibleColumns.fluorescent && <th>Fluorescent</th>}
              {visibleColumns.culet && <th>Culet</th>}
              {visibleColumns.certificate_number && <th>Cert. Number</th>}
              {/* {visibleColumns.location && <th>Location</th>} */}
              {/* {visibleColumns.created_at && <th>Created At</th>} */}
              {/* {visibleColumns.type && <th>Type</th>} */}
              {visibleColumns.certificate_url && <th>Certificate</th>}
            </tr>
          </thead>
          <tbody>
            {diamonds.map((diamond) => (
              <tr key={diamond.id}>
                {visibleColumns.id && <td>{diamond.id}</td>}
                {visibleColumns.image && (
                  <td>{formatValue("image_url", diamond.image_url)}</td>
                )}
                {visibleColumns.shape && <td>{diamond.shape}</td>}
                {visibleColumns.color && <td>{diamond.color}</td>}
                {visibleColumns.carat && <td>{diamond.carat}</td>}
                {visibleColumns.price_per_carat && (
                  <td>
                    {diamond.price_per_carat
                      ? formatValue("price_per_carat", diamond.price_per_carat)
                      : "-"}
                  </td>
                )}
                {visibleColumns.total_price && (
                  <td>
                    {diamond.total_price
                      ? formatValue("total_price", diamond.total_price)
                      : "-"}
                  </td>
                )}
                {visibleColumns.clarity && <td>{diamond.clarity}</td>}
                {visibleColumns.ratio && <td>{diamond.ratio}</td>}
                {visibleColumns.lab && <td>{diamond.lab}</td>}
                {visibleColumns.cut && <td>{diamond.cut || "-"}</td>}
                {visibleColumns.polish && <td>{diamond.polish || "-"}</td>}
                {visibleColumns.symmetry && <td>{diamond.symmetry || "-"}</td>}
                {visibleColumns.depth_percentage && (
                  <td>{diamond.depth_percentage}</td>
                )}
                {visibleColumns.table_percentage && (
                  <td>{diamond.table_percentage}</td>
                )}
                {visibleColumns.fluorescent && (
                  <td>{diamond.fluorescent || "-"}</td>
                )}
                {visibleColumns.culet && <td>{diamond.culet || "-"}</td>}
                {visibleColumns.certificate_number && (
                  <td>{diamond.certificate_number}</td>
                )}
                {/* {visibleColumns.location && <td>{diamond.location || "-"}</td>}
                {visibleColumns.created_at && (
                  <td>{formatValue("created_at", diamond.created_at)}</td>
                )}
                {visibleColumns.type && <td>{diamond.type}</td>} */}
                {visibleColumns.certificate_url && (
                  <td>
                    {formatValue("certificate_url", diamond.certificate_url)}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DiamondListView;
